import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0f0b6804&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0f0b6804&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b6804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0b6804')) {
      api.createRecord('0f0b6804', component.options)
    } else {
      api.reload('0f0b6804', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=0f0b6804&scoped=true", function () {
      api.rerender('0f0b6804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/footer/Footer.vue"
export default component.exports